export default {
  planting_pattern: [
    {
      value: "Agroforestry",
      text: "Agroforestry",
    },
    {
      value: "Konservasi",
      text: "Konservasi",
    },
    {
      value: "Pola Agroforestry Acak",
      text: "Pola Agroforestry Acak",
    },
    {
      value: "Pola Agroforestry Satu Jalur",
      text: "Pola Agroforestry Satu Jalur",
    },
    {
      value: "Pola Agroforestry Tepi",
      text: "Pola Agroforestry Tepi",
    },
    {
      value: "Pola Konservasi Pohon Kayu",
      text: "Pola Konservasi Pohon Kayu",
    },
    {
      value: "Pola Konservasi Pohon Kayu + MPTS",
      text: "Pola Konservasi Pohon Kayu + MPTS",
    },
  ],
  followed_project_model: [
    {
      label: "Model 1 - Pohon Kayu untuk Ditebang",
      code: 1,
    },
    {
      label: "Model 2 - Pohon Kayu untuk Ditebang + Pohon Buah/MPTS",
      code: 2,
    },
    {
      label: "Model 3 - Pohon Kayu dan Buah/MPTS tidak Ditebang",
      code: 3,
    },
  ],
  owned_land_legalization_status: [
    {
      label: "Sertifikat lahan atau Letter C atas nama sendiri",
      code: 1,
    },
    {
      label: "Akte Jual Beli atau Letter C masih atas nama Orang Lain",
      code: 2,
    },
    {
      label: "Lahan Waris atau Lahan Sewa atau Lahan Garapan",
      code: 3,
    },
  ],
};
